// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrap {
  padding: 10rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrap.absolute {
  background: var(--white);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1608;
}

.circle, .loader:before,
.loader:after, .loader {
  background-color: var(--primary);
  border-radius: 50%;
}

.loader {
  width: 2.4rem;
  height: 2.4rem;
  animation: loader 1s ease-in-out infinite;
}

.loader:before,
.loader:after {
  content: "";
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  top: 4px;
  opacity: 0.6;
}

.loader:before {
  right: 7.2rem;
}

.loader:after {
  left: 7.2rem;
}

@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/loader/loader.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,wBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;AACJ;;AAGA;;EACE,gCAAA;EACA,kBAAA;AACF;;AAEA;EAEE,aAAA;EACA,cAAA;EACA,yCAAA;AAAF;;AAGA;;EAGE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE;IACE,uBAAA;EADF;EAGA;IACE,yBAAA;EADF;EAGA;IACE,yBAAA;EADF;AACF","sourcesContent":[".wrap {\n  padding: 10rem 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &.absolute {\n    background: var(--white);\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    z-index: 1608;\n  }\n}\n\n.circle {\n  background-color: var(--primary);\n  border-radius: 50%;\n}\n\n.loader {\n  @extend .circle;\n  width: 2.4rem;\n  height: 2.4rem;\n  animation: loader 1s ease-in-out infinite;\n}\n\n.loader:before,\n.loader:after {\n  @extend .circle;\n  content: '';\n  width: 1.6rem;\n  height: 1.6rem;\n  position: absolute;\n  top: 4px;\n  opacity: 0.6;\n}\n\n.loader:before {\n  right: 7.2rem;\n}\n\n.loader:after {\n  left: 7.2rem;\n}\n\n@keyframes loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(180deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
